import React from 'react';
import { AlertCircle, RefreshCcw } from 'lucide-react';
import { Button } from '../ui/button';

/**
 * Error boundary for marketing pages.
 * Catches JS render errors and shows a friendly recovery UI.
 */
export class MarketingErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('[MarketingErrorBoundary]', error, errorInfo);
  }

  handleRetry = () => {
    this.setState({ hasError: false, error: null });
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex flex-col items-center justify-center h-64 gap-4 text-center px-4">
          <div className="p-4 rounded-full bg-[rgba(255,77,77,0.12)] border border-[rgba(255,77,77,0.22)]">
            <AlertCircle size={28} className="text-[#FF4D4D]" />
          </div>
          <div>
            <p className="text-[#F2F2F2] font-semibold mb-1">Something went wrong</p>
            <p className="text-[#B9B9B9] text-sm max-w-sm">
              {this.state.error?.message || 'An unexpected error occurred on this page.'}
            </p>
          </div>
          <Button
            onClick={this.handleRetry}
            variant="outline"
            className="bg-transparent border-[#2A2A2A] text-[#B9B9B9] hover:border-[#D4A843]/40 gap-2"
            data-testid="error-boundary-retry-button"
          >
            <RefreshCcw size={16} />
            Try again
          </Button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default MarketingErrorBoundary;
